import type { EffectDefinition } from "@/effects/types";

export const EXPOSURE_SHADER = "exposure";

function parseIntensity(effectParams: Record<string, unknown>): number {
	const raw = effectParams.intensity;
	return typeof raw === "number" ? raw : Number.parseFloat(String(raw));
}

/** intensity in [-100, 100], 0 = no change. Mapped to stops in [-2, 2], applied as
 * color * 2^stops (matches exposure.wgsl). */
export function intensityToExposureStops(intensity: number): number {
	return intensity / 50;
}

export const exposureEffectDefinition: EffectDefinition = {
	type: "exposure",
	name: "Экспозиция",
	keywords: ["exposure", "brightness", "light", "color"],
	params: [
		{
			key: "intensity",
			label: "Интенсивность",
			type: "number",
			default: 0,
			min: -100,
			max: 100,
			step: 1,
		},
	],
	renderer: {
		passes: [
			{
				shader: EXPOSURE_SHADER,
				uniforms: ({ effectParams }) => ({
					u_amount: intensityToExposureStops(parseIntensity(effectParams)),
				}),
			},
		],
	},
};
